<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="application.id === null">{{ 'APPLICATION.NEWAPPLICATION' | translate }}</span>
            <span *ngIf="application.id !== null">{{ 'APPLICATION.EDITAPPLICATION' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="applicationForm" id="applicationForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="applicationForm" >
            <input type="hidden" name="id" id="applicationId" formControlName="id" />
            <div class="p-fluid p-grid">
            
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationName" formControlName="name" type="text" pInputText [required]="false"> 
                      <label for="applicationName" class="">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationDescription" formControlName="description" type="text" pInputText [required]="false"> 
                      <label for="applicationDescription" class="">{{ 'DESCRIPTION' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
            
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationPrimaryColor" formControlName="primaryColor" type="text" pInputText [required]="false"> 
                      <label for="applicationPrimaryColor" class="">{{ 'Primary Color' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->

              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationSecondaryColor" formControlName="secondaryColor" type="text" pInputText [required]="false"> 
                      <label for="applicationSecondaryColor" class="">{{ 'Secondary Color' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            
            <div class="p-fluid p-grid">
              
              <div class="p-col-6">
               
                
                <div class="p-field p-col-12">
                  
                  <label for="logoUpload" class="p-text-bold">Logo Left</label>

                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>

                    <input type="file"  pButton icon="pi pi-folder" styleClass="p-button-info"  class="w-100" (change)="uploadLogoLeft($event)" accept="image/*" />
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <label class="p-text-bold">Logo Right</label>

                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>

                    <input type="file"  pButton pRipple icon="pi pi-folder" styleClass="p-button-info"  class="w-100" (change)="uploadLogoRight($event)" accept="image/*" />
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              
             

                <div class="p-field p-col-12">
                  <label for="backgroundUpload" class="p-text-bold">Background</label>

                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>

                    <input type="file"  pButton pRipple icon="pi pi-folder" styleClass="p-button-info"  class="w-100" (change)="uploadBackground($event)" accept="image/*" />
                  </div>
                </div>

            </div><!--/p-fluid p-grid-->
        
            <div class="p-fluid p-grid">
            
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-palette"></i>
                    </span>
                    <span class="p-inputgroup-addon" style="max-width: 1em;">
                      <p-colorPicker (onChange)="setColor($event)" formControlName="tabBar"></p-colorPicker>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationTabBar" formControlName="tabBar" type="text" pInputText [required]="false"> 
                      <label for="applicationTabBar" class="">{{ 'Tab Bar' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->

              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-palette"></i>
                    </span>
                    <span class="p-inputgroup-addon" style="max-width: 1em;">
                      <p-colorPicker (onChange)="setColorActivityStyleNotFocused($event)" formControlName="activityStyleNotFocused"></p-colorPicker>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationActivityStyleNotFocused" formControlName="activityStyleNotFocused" type="text" pInputText [required]="false"> 
                      <label for="applicationActivityStyleNotFocused" class="">{{ 'Activity Style Not Focused' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
         

            <div class="p-fluid p-grid">
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-palette"></i>
                    </span>
                    <span class="p-inputgroup-addon" style="max-width: 1em;">
                      <p-colorPicker (onChange)="setColorTabIconNotFocused($event)" formControlName="tabIconNotFocused"></p-colorPicker>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationTabIconNotFocused" formControlName="tabIconNotFocused" type="text" pInputText [required]="false">
                      <label for="applicationTabIconNotFocused" class="">{{ 'Tab Icon Not Focused' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
          
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-palette"></i>
                    </span>
                    <span class="p-inputgroup-addon" style="max-width: 1em;">
                      <p-colorPicker (onChange)="setColorTabIconFocused($event)" formControlName="tabIconFocused"></p-colorPicker>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationTabIconFocused" formControlName="tabIconFocused" type="text" pInputText [required]="false">
                      <label for="applicationTabIconFocused" class="">{{ 'Tab Icon Focused' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
          
            <div class="p-fluid p-grid">
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-palette"></i>
                    </span>
                    <span class="p-inputgroup-addon" style="max-width: 1em;">
                      <p-colorPicker (onChange)="setColorAddRemoveObjectifColor($event)" formControlName="addRemoveObjectifColor"></p-colorPicker>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationAddRemoveObjectifColor" formControlName="addRemoveObjectifColor" type="text" pInputText [required]="false">
                      <label for="applicationAddRemoveObjectifColor" class="">{{ 'Add Remove Objectif Color' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
          
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-palette"></i>
                    </span>
                    <span class="p-inputgroup-addon" style="max-width: 1em;">
                      <p-colorPicker (onChange)="setColorObjectifBackgroundColor($event)" formControlName="objectifBackgroundColor"></p-colorPicker>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationObjectifBackgroundColor" formControlName="objectifBackgroundColor" type="text" pInputText [required]="false">
                      <label for="applicationObjectifBackgroundColor" class="">{{ 'Objectif Background Color' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
          
            <div class="p-fluid p-grid">
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-palette"></i>
                    </span>
                    <span class="p-inputgroup-addon" style="max-width: 1em;">
                      <p-colorPicker (onChange)="setColorProgressBackgroundColor($event)" formControlName="progressBackgroundColor"></p-colorPicker>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationProgressBackgroundColor" formControlName="progressBackgroundColor" type="text" pInputText [required]="false">
                      <label for="applicationProgressBackgroundColor" class="">{{ 'Progress Background Color' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
          
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-palette"></i>
                    </span>
                    <span class="p-inputgroup-addon" style="max-width: 1em;">
                      <p-colorPicker (onChange)="setColorActiveGoalProgresseColor($event)" formControlName="activeGoalProgresseColor"></p-colorPicker>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationActiveGoalProgresseColor" formControlName="activeGoalProgresseColor" type="text" pInputText [required]="false">
                      <label for="applicationActiveGoalProgresseColor" class="">{{ 'Active Goal Progress Color' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
          
            <div class="p-fluid p-grid">
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-palette"></i>
                    </span>
                    <span class="p-inputgroup-addon" style="max-width: 1em;">
                      <p-colorPicker (onChange)="setColorProgressValueColor($event)" formControlName="progressValueColor"></p-colorPicker>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationProgressValueColor" formControlName="progressValueColor" type="text" pInputText [required]="false">
                      <label for="applicationProgressValueColor" class="">{{ 'Progress Value Color' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
          
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-palette"></i>
                    </span>
                    <span class="p-inputgroup-addon" style="max-width: 1em;">
                      <p-colorPicker (onChange)="setColorAjourdhisto($event)" formControlName="ajourdHisto"></p-colorPicker>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationAjourdhisto" formControlName="ajourdHisto" type="text" pInputText [required]="false">
                      <label for="applicationAjourdhisto" class="">{{ 'Ajourdhisto Color' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
          
            <div class="p-fluid p-grid">
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-palette"></i>
                    </span>
                    <span class="p-inputgroup-addon" style="max-width: 1em;">
                      <p-colorPicker (onChange)="setColorProfileColor($event)" formControlName="profileColor"></p-colorPicker>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationProfileColor" formControlName="profileColor" type="text" pInputText [required]="false">
                      <label for="applicationProfileColor" class="">{{ 'Profile Color' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationOffreId" formControlName="offreId" type="text" pInputText [required]="false"> 
                      <label for="applicationOffreId" class="">{{ 'OffreId' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">

              <!-- Third Color -->
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-paint-brush"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationThirdColor" formControlName="thirdColor" type="text" pInputText [required]="false"> 
                      <label for="applicationThirdColor">{{ 'Third Color' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            
              <!-- Fourth Color -->
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-paint-brush"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationFourthColor" formControlName="fourthColor" type="text" pInputText [required]="false"> 
                      <label for="applicationFourthColor">{{ 'Fourth Color' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            
              <!-- IC Step Color -->
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-paint-brush"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationICStepColor" formControlName="icStepColor" type="text" pInputText [required]="false"> 
                      <label for="applicationICStepColor">{{ 'IC Step Color' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            
              <!-- IC Collected Point Color -->
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-paint-brush"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationICCollectedPointColor" formControlName="icCollectedPointColor" type="text" pInputText [required]="false"> 
                      <label for="applicationICCollectedPointColor">{{ 'IC Collected Point Color' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            
              <!-- IC Duration Color -->
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-paint-brush"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationICDurationColor" formControlName="icDurationColor" type="text" pInputText [required]="false"> 
                      <label for="applicationICDurationColor">{{ 'IC Duration Color' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            
              <!-- IC Position Color -->
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-paint-brush"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationICPositionColor" formControlName="icPositionColor" type="text" pInputText [required]="false"> 
                      <label for="applicationICPositionColor">{{ 'IC Position Color' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            
              <!-- Background Color Primary -->
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-paint-brush"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationBackgroundColorPrimary" formControlName="backgroundColorPrimary" type="text" pInputText [required]="false"> 
                      <label for="applicationBackgroundColorPrimary">{{ 'Background Color Primary' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            
              <!-- Background Color Secondary -->
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-paint-brush"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationBackgroundColorSecondary" formControlName="backgroundColorSecondary" type="text" pInputText [required]="false"> 
                      <label for="applicationBackgroundColorSecondary">{{ 'Background Color Secondary' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            
              <!-- Button Color Primary -->
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-paint-brush"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationButtonColorPrimary" formControlName="buttonColorPrimary" type="text" pInputText [required]="false"> 
                      <label for="applicationButtonColorPrimary">{{ 'Button Color Primary' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            
              <!-- Button Color Secondary -->
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-paint-brush"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationButtonColorSecondary" formControlName="buttonColorSecondary" type="text" pInputText [required]="false"> 
                      <label for="applicationButtonColorSecondary">{{ 'Button Color Secondary' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            
              <!-- Placeholder Text -->
              <div class="p-col-6">
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-text-height"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="applicationPlaceholderText" formControlName="placeholderText" type="text" pInputText [required]="false"> 
                      <label for="applicationPlaceholderText">{{ 'Placeholder Text' | translate }}</label>
                    </span>
                  </div>
                </div>
              </div><!--/p-col-6-->
            
            </div><!--/p-fluid p-grid-->
            
            <!-- Existing submit button -->
            <div class="p-fluid p-grid">
              <div class="p-col-12">
                <button type="submit" [disabled]="applicationForm.invalid" class="p-button p-button-primary">{{ 'Save' | translate }}</button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

